// composables/useApiMetrics.js
//
// Emisor client-side de telemetría de APIs externas (Maps/Places, etc.).
// Las llamadas a SDKs de Google ocurren en el navegador: el servidor nunca
// las ve, por eso se reportan con un beacon a /api/_metrics/track.
//
// - Solo corre en cliente (guard process.client).
// - Fire-and-forget: usa sendBeacon, no espera respuesta, nunca rompe la UI.
// - La ruta se toma del router (más fiable que el referer tras navegación SPA).

export const useApiMetrics = () => {
  const route = useRoute()

  function track(provider, evento, componente) {
    if (globalThis.window == undefined) return
    try {
      const body = JSON.stringify({
        provider,
        evento,
        componente,
        ruta: route.path,
      })
      const blob = new Blob([body], { type: 'application/json' })

      if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/_metrics/track', blob)
      } else {
        // Fallback: keepalive para sobrevivir a la navegación. El Content-Type
        // es necesario para que readBody parsee el JSON en el servidor.
        fetch('/api/_metrics/track', {
          method: 'POST',
          body,
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
        }).catch(() => {})
      }
    } catch (error) {
      // La observabilidad nunca rompe la UI.
      console.warn('useApiMetrics track failed', error)
    }
  }

  return { track }
}
